import { kebabCase } from '../utils';

export const searchVariations = (variations: any, values: any, key?: any) => {
  const vari: any[] = [];

  variations?.edges.forEach((element: any) => {
    const isvalid = Object.keys(values).every((keyObject) => {
      const isNotQuantityAttribute = keyObject !== 'cantidad';
      const hasDiferentName = kebabCase(keyObject) !== kebabCase(key);
      const shouldBeChecked = key
        ? isNotQuantityAttribute && hasDiferentName
        : isNotQuantityAttribute;

      return shouldBeChecked
        ? element.node.attributes.nodes.every((attr: any) => {
            const hasValue =
              typeof values[keyObject] === 'object'
                ? values[keyObject].length > 0
                : values[keyObject]
                  ? true
                  : false;
            const hasSameValue =
              kebabCase(attr.value) ===
              kebabCase(
                typeof values[keyObject] === 'object'
                  ? values[keyObject]?.at(0)
                  : values[keyObject],
              );
            const hasSameName = kebabCase(keyObject) === kebabCase(attr.name);

            if (hasSameName && hasSameValue) return true;
            else if (hasSameName && hasValue) return false;
            else return true;
          })
        : true;
    });

    if (isvalid) vari.push(element);
  });

  return vari;
};
